import isEmail from 'validator/lib/isEmail';
import matches from 'validator/lib/matches';
import isEmpty from 'validator/lib/isEmpty';
import { createField, updateField } from '../../actions';
import { EVENT_STEP_VALIDATE } from '../../helpers/consts';

export class EmailField {
    constructor(options) {
        this.validateMessages = {
            bogusData: __('Did a cat run over your keyboard?'),
            validCharacters: __('Only use letters and symbols.'),
            notValid: __('We cannot validate your email'),
            noNoReply: __('No &apos;no reply&apos; or &apos;test&apos; address allowed'),
            noHTML: __('No html allowed'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id );
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = false;
        this.$el = this.createFieldElement();

        if (this.value !== '') {
            this.validate();
        }
    }

    createFieldElement () { // eslint-disable-line class-methods-use-this
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$fieldInput = document.createElement('input');
        this.$fieldMessage = document.createElement('span');

        this.$fieldInput.type = 'email';
        this.$fieldInput.id = this.id;
        this.$fieldInput.required = this.required;
        this.$fieldInput.value = this.value;
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', 'field--email')
        $fieldLabel.classList.add('field-label');
        this.$fieldInput.classList.add('field-input', 'form-control', 'field-input--email');
        this.$fieldMessage.classList.add('invalid-feedback');

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$fieldInput);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldInput.addEventListener('blur', this.validate.bind(this));

        return $field;
    }

    validate() {
        this.$fieldInput.classList.remove('is-valid');
        this.isValid = false;

        if(matches(this.$fieldInput.value, /((asdff|asdf|asdasd|qwer))+/ig)) {
            // Valid email check on bogus data
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.bogusData;
        } else if(matches(this.$fieldInput.value, /^((#|%|!|&|=|>|<|,|:|;|"|').)*$/g)) {
            // Email check on invalid characters
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.validCharacters;
        } else if(matches(this.$fieldInput.value, /((noreply|test@test).)+/ig)) {
            // No 'no reply' address allowed
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.noNoReply;
        } else if(matches(this.$fieldInput.value, /<[^>]*>/g)) {
            // No html allowed
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.noHTML;
        } else if (!isEmail(this.$fieldInput.value)) {
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.notValid;
        } else if (isEmail(this.$fieldInput.value)) {
            this.$fieldInput.classList.remove('is-invalid');
            this.$fieldInput.classList.add('is-valid');
            this.isValid = true;
        }

        if(isEmpty(this.$fieldInput.value)) {
            this.$fieldInput.classList.remove('is-invalid');
            this.$fieldInput.classList.remove('is-valid');
            this.isValid = false;

            if (this.required) {
                this.$fieldInput.classList.add('is-invalid');
            }
        }

        if (this.isValid) {
            this.store.dispatch(updateField(this.id, this.$fieldInput.value, this.isValid, this.label));
        }
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default EmailField;
